import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";
import { HERO_STATS } from "../../mock/mockData";

const Marquee = () => {
  const items = [
    "100% LÍTIO",
    "●",
    "1 ANO GARANTIA BATERIA",
    "●",
    "+537€ MARGEM MÍNIMA",
    "●",
    "STOCK EM PORTUGAL",
    "●",
    "LISBOA + VAGOS",
    "●",
    "REVENDEDORES 2026",
    "●",
  ];
  const row = [...items, ...items, ...items];
  return (
    <div className="bg-black text-[#FFD60A] border-y-[3px] border-black overflow-hidden">
      <div className="marquee-track py-3">
        {row.map((t, i) => (
          <span key={i} className="mono text-[13px] md:text-[15px] uppercase font-bold tracking-widest px-6 whitespace-nowrap">
            {t}
          </span>
        ))}
      </div>
    </div>
  );
};

const Hero = () => {
  return (
    <section id="top" className="relative">
      {/* Top utility bar */}
      <div className="bg-[#FFD60A] border-b-[3px] border-black">
        <div className="max-w-[1440px] mx-auto px-4 md:px-10 py-2 flex items-center justify-between gap-3 overflow-hidden mono text-[11px] uppercase font-medium tracking-wider">
          <span className="flex items-center gap-2 min-w-0">
            <span className="w-2 h-2 bg-black inline-block"></span>
            <span className="hidden sm:inline truncate">Programa B2B · Revendedores 2026</span>
            <span className="sm:hidden truncate">B2B · 2026</span>
          </span>
          <span className="hidden md:inline">Tabela válida desde 05/05/2026</span>
          <span className="flex-shrink-0">PT · €</span>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-4 md:px-10 pt-10 md:pt-16 pb-8 overflow-hidden">
        {/* Tag row */}
        <div className="flex flex-wrap items-center gap-3 mb-8">
          <span className="mono text-[10px] sm:text-[11px] uppercase tracking-widest px-3 py-1 brut-border bg-white">
            ◆ Cap. 00 / Intro
          </span>
          <span className="mono text-[10px] sm:text-[11px] uppercase tracking-widest px-3 py-1 bg-black text-[#FFD60A]">
            Veentto Vagos
          </span>
          <span className="mono text-[10px] sm:text-[11px] uppercase tracking-widest px-3 py-1 brut-border bg-[#E63946] text-white">
            Margem +537€
          </span>
        </div>

        {/* Massive Headline */}
        <h1 className="display font-bold text-[38px] min-[380px]:text-[42px] sm:text-[68px] md:text-[104px] lg:text-[138px] xl:text-[160px] leading-[0.88] break-words max-w-full">
          A única gama
          <br />
          <span className="italic font-normal">100% lítio</span>
          <br />
          com presença em
          <br />
          <span className="inline-block bg-[#E63946] text-white px-2 min-[380px]:px-3 md:px-6 -rotate-1">Lisboa</span>
          <span className="mx-1 min-[380px]:mx-2 md:mx-4">&amp;</span>
          <span className="inline-block bg-black text-[#FFD60A] px-2 min-[380px]:px-3 md:px-6 rotate-1">Vagos</span>
          <span className="inline-block ml-3 md:ml-5 text-[#E63946]">.</span>
        </h1>

        <div className="mt-10 md:mt-14 grid md:grid-cols-[1.2fr_1fr] gap-8 md:gap-12 items-end">
          <p className="text-[16px] md:text-[20px] leading-[1.4] max-w-[640px]">
            Enquanto grande parte do mercado ainda compara scooters com chumbo-ácido, a Veentto Vagos trabalha
            <span className="bg-[#FFD60A] px-1"> exclusivamente com baterias de lítio</span>. Toda a gama (Power, Nice, Briza · 48V e 60V) é 100% lítio — mais leve, mais durável, com
            <span className="font-bold"> 1 ano de garantia na bateria</span> e margem revendedor a partir de
            <span className="bg-black text-white px-1 font-bold"> +537 €/unidade</span>.
          </p>

          <div className="flex flex-col sm:flex-row md:flex-col gap-4 min-w-0">
            <a
              href="#candidatura"
              className="group inline-flex w-full sm:w-auto items-center justify-between gap-3 bg-[#E63946] text-white font-bold mono text-[13px] sm:text-[14px] uppercase tracking-wider px-5 sm:px-6 py-5 brut-border brut-btn"
            >
              Candidatar-me agora
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#modelos"
              className="group inline-flex w-full sm:w-auto items-center justify-between gap-3 bg-white font-bold mono text-[13px] sm:text-[14px] uppercase tracking-wider px-5 sm:px-6 py-5 brut-border brut-btn"
            >
              Ver gama completa
              <ArrowDown size={20} className="group-hover:translate-y-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>

      <Marquee />

      {/* Stats grid */}
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-0 brut-border-thick bg-black">
          {HERO_STATS.map((s, i) => (
            <div
              key={i}
              className={`bg-[#F4F0E8] p-5 md:p-6 ${
                i % 2 === 1 ? "md:bg-white" : ""
              } border-black ${
                i < 3 ? "border-b-[3px] lg:border-b-0" : ""
              } ${
                (i + 1) % 2 === 0 && "md:border-l-[3px]"
              } lg:border-l-[3px] first:lg:border-l-0`}
            >
              <div className="display text-[36px] md:text-[44px] font-bold leading-none">{s.value}</div>
              <div className="mt-2 mono text-[11px] uppercase tracking-widest text-black/70">{s.label}</div>
              <div className="mt-1 text-[12px] text-black/60">{s.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
